/**
 * Personal Catalog Builder store — staff (salesperson / admin / major admin /
 * super admin) browse the same public storefront the customer sees, add pieces
 * to their builder, then Generate PDF. Selection persists for the whole login
 * day via localStorage.
 */
const KEY = "sg_pcb_items";
const EVENT = "sg-pcb-changed";

export const pcbGet = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};

const save = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event(EVENT));
};

export const pcbAdd = (product) => {
  const items = pcbGet();
  if (items.some((p) => p.id === product.id)) return false; // already added
  items.push({ id: product.id, name: product.name, image: (product.images || [])[0] || "", purity: product.purity, metal: product.metal, weight_grams: product.weight_grams });
  save(items);
  return true;
};

export const pcbRemove = (id) => save(pcbGet().filter((p) => p.id !== id));
export const pcbClear = () => save([]);
export const pcbHas = (id) => pcbGet().some((p) => p.id === id);
export const pcbSubscribe = (fn) => {
  window.addEventListener(EVENT, fn);
  window.addEventListener("storage", fn);
  return () => { window.removeEventListener(EVENT, fn); window.removeEventListener("storage", fn); };
};

export const STAFF_ROLES = ["salesperson", "admin", "major_admin", "super_admin"];
export const isStaffRole = (role) => STAFF_ROLES.includes(role);
// Customers can also curate their own catalog (PDF is marked "generated by the customer")
export const canBuildCatalog = (role) => isStaffRole(role) || role === "customer" || role === "user";
